import "../../../../vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import Platform, { isRuntimeSsrPreHydration } from "./plugins/platform/Platform.es.js";
import Screen from "./plugins/screen/Screen.es.js";
import Plugin from "./plugins/dark/Dark.es.js";
import Body from "./plugins/private.body/Body.es.js";
import History from "./plugins/private.history/History.es.js";
import Plugin$1 from "./plugins/lang/Lang.es.js";
import Plugin$2 from "./plugins/icon-set/IconSet.es.js";
import { quasarKey } from "./utils/private.symbols/symbols.es.js";
import { globalConfig, globalConfigIsFrozen, freezeGlobalConfig } from "./utils/private.config/instance-config.es.js";
import { isObject } from "./utils/is/is.es.js";
const autoInstalledPlugins = [
  Platform,
  Body,
  Plugin,
  Screen,
  History,
  Plugin$1,
  Plugin$2
];
function installPlugins(pluginOpts, pluginList) {
  pluginList.forEach((Plugin2) => {
    Plugin2.install(pluginOpts);
    Plugin2.__installed = true;
  });
}
function prepareApp(app, uiOpts, pluginOpts) {
  app.config.globalProperties.$q = pluginOpts.$q;
  app.provide(quasarKey, pluginOpts.$q);
  installPlugins(pluginOpts, autoInstalledPlugins);
  uiOpts.components !== void 0 && Object.values(uiOpts.components).forEach((c) => {
    if (isObject(c) === true && c.name !== void 0) {
      app.component(c.name, c);
    }
  });
  uiOpts.directives !== void 0 && Object.values(uiOpts.directives).forEach((d) => {
    if (isObject(d) === true && d.name !== void 0) {
      app.directive(d.name, d);
    }
  });
  uiOpts.plugins !== void 0 && installPlugins(
    pluginOpts,
    Object.values(uiOpts.plugins).filter(
      (p) => typeof p.install === "function" && autoInstalledPlugins.includes(p) === false
    )
  );
  if (isRuntimeSsrPreHydration.value === true) {
    pluginOpts.$q.onSSRHydrated = () => {
      pluginOpts.onSSRHydrated.forEach((fn) => {
        fn();
      });
      pluginOpts.$q.onSSRHydrated = () => {
      };
    };
  }
}
const installQuasar = function(parentApp, opts = {}) {
  const $q = { version: "2.17.4" };
  if (globalConfigIsFrozen === false) {
    if (opts.config !== void 0) {
      Object.assign(globalConfig, opts.config);
    }
    $q.config = { ...globalConfig };
    freezeGlobalConfig();
  } else {
    $q.config = opts.config || {};
  }
  prepareApp(parentApp, opts, {
    parentApp,
    $q,
    lang: opts.lang,
    iconSet: opts.iconSet,
    onSSRHydrated: []
  });
};
export {
  installQuasar as default
};
//# sourceMappingURL=install-quasar.es.js.map
